import { Modal, Result, Button } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

export const DuplicateMacModal = ({
  isModalOpen,
  setModal,
  modal,
  isModalForm,
}) => {
  const navigate = useNavigate();
  // Filter details into success and error categories
  // const successItems = modal?.filter((item) => item.status === 200) || [];
  const errorItems = modal?.filter((item) => item.status === 400) || [];

  // const totalItems = modal?.length || 0;
  // const successCount = successItems.length;
  // const errorCount = errorItems.length;

  return (
    <Modal
      title={null}
      open={isModalOpen}
      onCancel={() => {
        setModal(null);
        !isModalForm && navigate(-1);
      }}
      footer={null}
      width={650}
      centered
    >
      <Result
        status="error"
        icon={<ExclamationCircleOutlined />}
        title="Duplicate MAC Addresses Detected"
        subTitle={
          <div className="text-gray-600">
            {errorItems.length > 0 && (
              <div className="space-y-2">
                <div className="text-sm mb-3">
                  The following MAC addresses are duplicates:
                </div>
                <div className="gap-2 flex items-center flex-wrap justify-center">
                  {errorItems.map((item, index) => (
                    <div
                      key={index}
                      className="bg-red-50 border border-red-200 rounded px-3 pb-0.5"
                    >
                      <code className="text-red-700 text-[12px] font-medium">
                        {item.mac}
                      </code>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        }
      />

      {/* Action Buttons */}
      {/* <div className="flex justify-center">
        <Button
          type="primary"
          onClick={() => {
            setModal(null);
            navigate(-1);
          }}
        >
          Close
        </Button>
      </div> */}
    </Modal>
  );
};

// <div className="px-6 pb-4">
//   {/* Summary Stats */}
//   <div className="flex justify-center gap-6 mb-6">
//     <div className="text-center">
//       <div className="flex items-center justify-center gap-2 mb-1">
//         <FaCheckCircle className="text-green-500" />
//         <Text strong className="text-green-600">
//           Success
//         </Text>
//       </div>
//       <Title level={2} className="text-green-600 m-0">
//         {successCount}
//       </Title>
//     </div>

//     <Divider type="vertical" className="h-16" />

//     <div className="text-center">
//       <div className="flex items-center justify-center gap-2 mb-1">
//         <FaTimesCircle className="text-red-500" />
//         <Text strong className="text-red-600">
//           Duplicates
//         </Text>
//       </div>
//       <Title level={2} className="text-red-600 m-0">
//         {errorCount}
//       </Title>
//     </div>
//   </div>

//   {/* Error Details */}
//   {errorCount > 0 && (
//     <div className="mb-4">
//       <Title
//         level={4}
//         className="text-red-600 mb-3 flex items-center gap-2"
//       >
//         <FaTimesCircle /> Duplicate MAC Addresses
//       </Title>
//       <div className="max-h-48 overflow-y-auto bg-red-50 rounded-lg p-3 border border-red-200">
//         <List
//           size="small"
//           dataSource={errorItems}
//           renderItem={(item) => (
//             <List.Item className="border-0 py-2">
//               <div className="flex items-center justify-between w-full">
//                 <div className="flex items-center gap-3">
//                   <code className="bg-red-100 text-red-700 px-2 py-1 rounded text-sm font-mono">
//                     {item.mac}
//                   </code>
//                   <Text className="text-red-600 text-sm">
//                     {item.message}
//                   </Text>
//                 </div>
//                 <Tag color="red" className="m-0">
//                   Duplicate
//                 </Tag>
//               </div>
//             </List.Item>
//           )}
//         />
//       </div>
//     </div>
//   )}

//   {/* Success Details */}
//   {successCount > 0 && (
//     <div className="mb-6">
//       <Title
//         level={4}
//         className="text-green-600 mb-3 flex items-center gap-2"
//       >
//         <FaCheckCircle /> Successfully Added
//       </Title>
//       <div className="max-h-32 overflow-y-auto bg-green-50 rounded-lg p-3 border border-green-200">
//         <div className="flex flex-wrap gap-2">
//           {successItems.map((item, index) => (
//             <code
//               key={index}
//               className="bg-green-100 text-green-700 px-2 py-1 rounded text-sm font-mono"
//             >
//               {item.mac}
//             </code>
//           ))}
//         </div>
//       </div>
//     </div>
//   )}
// </div>;
